import clsx from 'clsx'
import { Link, useLocation } from 'react-router'
import classes from './Navigation.module.css'
import { Typography } from '../common/typography'

interface NavigationPage {
  label: string
  link: string
  icon: React.ComponentType<{ className?: string }>
  isCompetition: boolean
  requiredFeature: string | null
}

interface NavigationMobileProps {
  setMobileNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>
  pagesWithCompetitionType: NavigationPage[]
  competition_id: number
}

interface PageProps {
  icon: React.ComponentType<{ className?: string }>
  label: string
  link: string
  setMobileNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>
  location_pathname: string
}

function PageMobile({
  icon: Icon,
  label,
  link,
  setMobileNavigationOpen,
  location_pathname,
}: PageProps) {
  const isActive = location_pathname
    .toLowerCase()
    .startsWith(link.toLowerCase())

  const fc = isActive
    ? { light: 'primary-6', dark: 'primary-3' }
    : { light: 'gray-9', dark: 'gray-3' }

  return (
    <Link
      to={link}
      className={clsx(classes.link, classes.linkMobile)}
      onClick={() => setTimeout(() => setMobileNavigationOpen(false), 100)}
    >
      <div className={classes.gridItem}>
        {Icon && (
          <Icon
            className={clsx(
              classes.icon,
              { [classes.active]: isActive },
              { [classes.clairIcon]: label === 'Ask Clair' }
            )}
          />
        )}
        <Typography
          fc={fc}
          hc={{ light: 'primary-6', dark: 'primary-3' }}
          fw={500}
        >
          {label}
        </Typography>
      </div>
    </Link>
  )
}

export default function NavigationMobile({
  pagesWithCompetitionType,
  setMobileNavigationOpen,
  competition_id,
}: NavigationMobileProps) {
  const { pathname } = useLocation()

  const links = pagesWithCompetitionType.map((item) => {
    const adjustedLink = item.isCompetition
      ? `/competitions/${competition_id}${item.link}`
      : item.link

    return (
      <PageMobile
        {...item}
        key={item.label}
        label={item.label === 'League Ladder' ? 'League' : item.label}
        link={adjustedLink}
        setMobileNavigationOpen={setMobileNavigationOpen}
        location_pathname={pathname}
      />
    )
  })

  return <div className={classes.grid}>{links}</div>
}
